import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcBlock24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm-7 9a7 7 0 0 0 11.192 5.606l-9.798-9.798a6.969 6.969 0 0 0 -1.394 4.192zm7-7a6.969 6.969 0 0 0 -4.192 1.394l9.798 9.798a7 7 0 0 0 -5.606-11.192z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcBlock24;
